import { render, staticRenderFns } from "./PepListaDocumento.vue?vue&type=template&id=0f088762&"
import script from "./PepListaDocumento.vue?vue&type=script&lang=js&"
export * from "./PepListaDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports